import { Injectable, inject } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import { PhoneNumbersRepositoryFailure } from '../../../domain/phone-numbers/failure';
import { IPhoneNumbersRepository } from '../../../domain/phone-numbers/i-phone-numbers-repository';
import { CompanyPhoneNumber } from '../../../domain/phone-numbers/types';
import { ApiResponse } from '../../../util/type';
import { IHttpClient } from '../../services/httpClient/interface';

@Injectable({
  providedIn: 'root',
})
export class RealPhoneNumbersRepository implements IPhoneNumbersRepository {
  private httpClient = inject(IHttpClient);

  public async getList(): Promise<Either<PhoneNumbersRepositoryFailure, CompanyPhoneNumber[]>> {
    try {
      const { body } =
        await this.httpClient.get<ApiResponse<CompanyPhoneNumber[]>>('/whatsapp/phone-numbers');
      return Right(body.data);
    } catch (error) {
      return Left(
        PhoneNumbersRepositoryFailure.fromApiError({
          error,
          fallbackMessage: 'Não foi possível carregar os números corporativos.',
        })
      );
    }
  }
}
